/*
 * PVJ - cart popover
 *
 * Trims the theme's "added to your bag" card back to what the wishlist card
 * shows: the piece, its name, its price.
 *
 * theme.js builds that card from the /cart/add.js line item, whose `title` is
 * the product and the variant joined ("Orvalho Ring - Certified sterling silver
 * and 3.38 carat beryl / Silver / 12"). It puts that whole string in the
 * heading, again in the title, and then the variant on its own line underneath
 * - so the variant is read three times in a card 300px wide, and the piece's
 * actual name is buried in it.
 *
 * The line item also carries `product_title`, which is the name on its own.
 * Using that for the heading and the title, and emptying the variant line,
 * leaves the card saying one thing. theme.css already hides
 * .popover-item-variant:empty (along with the selling plan, properties and unit
 * price lines, which are empty on every PVJ product), so nothing has to be
 * hidden by hand.
 *
 * The quantity prefix goes too. It is rendered as "(1) " on every card, because
 * the product page has no quantity picker (theme.settings.showQuantity is off),
 * so it never said anything - but it is kept for a genuine multiple, which is
 * the one case where it would.
 *
 * Done after the fact rather than in the template, because theme.js writes all
 * of these unconditionally and would throw on a missing element. This runs in
 * the same click - theme.js's cart-popover listens for theme:product:add too,
 * and layout/theme.liquid loads theme.js first, so its card is already in the
 * DOM by the time this runs, and the text is corrected before the browser
 * paints it.
 */
(function () {
  'use strict';

  var STRIP_HTML = /(<([^>]+)>)/gi;

  /*
   * The suffix ("added to your bag", translated) is the heading's text as it
   * sits in the template - theme.js reads it there and prefixes it, so the
   * template still holds the clean copy after the card has been built.
   */
  function headingSuffix() {
    var template = document.querySelector('cart-popover [data-popover-template]');
    var heading = template && template.content.querySelector('[data-popover-heading]');

    return heading ? heading.textContent.trim() : '';
  }

  document.addEventListener('theme:product:add', function (event) {
    var detail = event.detail;
    var response = detail && detail.response;

    // An error card carries Shopify's message and none of these elements.
    if (!response || response.status) return;

    var holder = document.querySelector('cart-popover [data-popover]');

    if (!holder) return;

    var productTitle = (response.product_title || '').replace(STRIP_HTML, '');

    if (!productTitle) return;

    var quantity = parseInt(detail.quantity, 10);
    var heading = holder.querySelector('[data-popover-heading]');
    var title = holder.querySelector('[data-popover-title]');
    var variant = holder.querySelector('[data-popover-variant]');

    if (heading) {
      heading.textContent = (quantity > 1 ? '(' + quantity + ') ' : '') + productTitle + ' ' + headingSuffix();
    }

    if (title) title.textContent = productTitle;
    if (variant) variant.textContent = '';
  });
})();
